import { useState } from "react";
import { useSEO } from "../lib/seo";
import { Mail, MessageSquare, Building2, Send } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  useSEO({
    title: "Contact BeforeExam",
    description: "Get in touch — sales, support, partnerships, team licenses. We respond within 24 hours.",
  });

  const [form, setForm] = useState({ name: "", email: "", topic: "support", message: "" });
  const submit = (e) => {
    e.preventDefault();
    // In production this would POST to a backend endpoint or email API.
    toast.success("Thanks — we'll get back to you within 24 hours.");
    setForm({ name: "", email: "", topic: "support", message: "" });
  };

  return (
    <div data-testid="contact-page">
      <section className="border-b border-border bg-[color:var(--brand-cream-2)]">
        <div className="container-x py-12 max-w-3xl">
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Talk to <span className="font-serif text-gradient-gold">us</span>.</h1>
          <p className="mt-3 text-muted-foreground">Whether you're a learner, a hiring manager, or a Fortune 500 L&D lead — we'll get back within 24 hours.</p>
        </div>
      </section>

      <section className="container-x py-14 grid lg:grid-cols-[1fr_320px] gap-10">
        <form onSubmit={submit} className="space-y-4 max-w-xl" data-testid="contact-form">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Name</label>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 h-11 w-full rounded-md border border-border bg-background px-3 text-sm outline-none focus:border-foreground" data-testid="contact-name" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Email</label>
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 h-11 w-full rounded-md border border-border bg-background px-3 text-sm outline-none focus:border-foreground" data-testid="contact-email" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Topic</label>
            <select value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} className="mt-1 h-11 w-full rounded-md border border-border bg-background px-3 text-sm" data-testid="contact-topic">
              <option value="support">Support</option>
              <option value="sales">Sales / Team licenses</option>
              <option value="partnership">Partnership</option>
              <option value="press">Press / Media</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Message</label>
            <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm outline-none focus:border-foreground" data-testid="contact-message" />
          </div>
          <button type="submit" className="btn-primary" data-testid="contact-submit">Send <Send className="h-4 w-4" /></button>
        </form>

        <aside className="space-y-3">
          {[
            { i: <Mail className="h-5 w-5 text-[color:var(--brand-amber)]" />, t: "Email us", d: "hello@beforeexam.com" },
            { i: <MessageSquare className="h-5 w-5 text-[color:var(--brand-success)]" />, t: "Live chat", d: "Mon–Fri · 9am–6pm IST" },
            { i: <Building2 className="h-5 w-5 text-[color:var(--brand-gold-deep)]" />, t: "Team licenses", d: "5+ seats · email sales@beforeexam.com" },
          ].map((b) => (
            <div key={b.t} className="rounded-xl border border-border bg-card p-5 flex items-start gap-3">
              {b.i}
              <div>
                <div className="font-semibold text-sm">{b.t}</div>
                <div className="text-sm text-muted-foreground">{b.d}</div>
              </div>
            </div>
          ))}
        </aside>
      </section>
    </div>
  );
}
